import { Shimmer } from '@components/Shimmer'
import { useMemo } from 'react'
import { Stack, XStack, YStack, useMedia } from 'tamagui'

export function PathGhostLoading() {
  const media = useMedia()
  const numberOfSlides = useMemo(() => {
    return media.gtMd ? [1, 2, 3, 4, 5] : [1, 2]
  }, [media.gtMd])

  return (
    <YStack testID="path-ghost-loading" flex={1}>
      <Stack
        flexDirection="column"
        marginBottom={40}
        marginTop={100}
        p={'$size.spacing-xs'}
      >
        <Stack>
          <YStack alignSelf="baseline" gap={20}>
            <Shimmer width={100} height={16} />
            <Shimmer width={250} height={35} />
          </YStack>
        </Stack>
      </Stack>
      <YStack
        gap={20}
        bg="$bg-page"
        p="$size.spacing-xs"
        flex={1}
        height="100%"
      >
        <Shimmer width={250} height={30} />
        <XStack gap={16}>
          {numberOfSlides.map((slide) => (
            <Shimmer
              key={slide}
              width={200}
              height={120}
              $gtMd={{
                width: 350,
                height: 150,
              }}
            />
          ))}
        </XStack>
      </YStack>
    </YStack>
  )
}
